<template>
    <div>
        <v-row class='justify-center'>
            <v-image-input
                class='ml-10'
                v-model="imageData"
                :image-quality="0.85"
                clearable
                image-format="jpeg"
                :hideActions="false"
                :imageHeight=150
                :imageWidth=150
            />
        </v-row>
        <v-row class="justify-center">
            <v-alert v-show="showError" border="bottom" colored-border type="error" elevation="1" >Image is mandatory .</v-alert>
        </v-row>
        <v-row class='justify-center'>
            <v-btn class="white--text" color='#ff676e' @click="changeFileUpload">
                Save
            </v-btn>
        </v-row>
    </div>
</template>

<script>
import VImageInput from 'vuetify-image-input/a-la-carte';

export default {
    components: {
        VImageInput
    },
    data(){
        return {
            imageData : '',
            imageObj : '',
            showError : false
        }
    },
    methods : {
        dataURLtoFile(dataurl, filename) {
            var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
            while(n--){
                u8arr[n] = bstr.charCodeAt(n);
            }
            return new File([u8arr], filename, {type:mime});
        },
        changeFileUpload(){
            if(this.imageData != '')
            {
                this.showError = false;
                this.imageObj = this.dataURLtoFile(this.imageData,'fileImage.jpeg');
                console.log(this.imageObj);
                this.$emit('onFileChange', this.imageObj);
            }
            else
            {
                this.showError = true;
            }
        }
    }
}
</script>